// Роли сервиса (FR-010) и их пояснения — дословно из contracts/rights-matrix.md.
import { z } from '../kernel/zod.ts';
import { fieldMessages } from '../kernel/field-messages.ts';

/** Порядок — как в колонках матрицы прав. */
export const roles = [
  'client_admin',
  'controller',
  'lead',
  'chair',
  'observer',
  'support',
] as const;

export type Role = (typeof roles)[number];

export const RoleSchema = z.enum(roles);

/** Роль во входящих данных формы — с текстом ошибки поля. */
export const RoleInputSchema = z.enum(roles, { error: fieldMessages.role });

export interface RoleInfo {
  /** Название с заглавной: заголовок колонки, подпись в списке ролей. */
  readonly title: string;
  /** Название внутри фразы: «Роль контролёр снята», «Замещаете: контролёр до 31.10». */
  readonly inText: string;
  /** Пояснение роли для экрана «Роли и права» (FR-015а). */
  readonly description: string;
}

export const roleInfo = {
  client_admin: {
    title: 'Администратор клиента',
    inText: 'администратор клиента',
    description: 'пользователи, роли, настройки, доступ сопровождения, все записи журнала.',
  },
  controller: {
    title: 'Контролёр',
    inText: 'контролёр',
    description: 'справочники, очереди, сообщения по всем документам своих областей.',
  },
  lead: {
    title: 'Ведущий',
    inText: 'ведущий',
    description: 'свои документы: загрузка, отчёт, список правок.',
  },
  chair: {
    title: 'Председатель',
    inText: 'председатель',
    description: 'просмотр, печать, стоп-кран; обычно работает без входа.',
  },
  observer: {
    title: 'Наблюдатель',
    inText: 'наблюдатель',
    description: 'только просмотр в своих областях.',
  },
  support: {
    title: 'Сопровождение',
    inText: 'сопровождение',
    description:
      'технические экраны без персональных данных; содержимое — только по временному доступу.',
  },
} as const satisfies Record<Role, RoleInfo>;

/** У этих ролей область — только «вся установка», без выбора (FR-013в). */
export const installationOnlyRoles = ['client_admin', 'support'] as const satisfies readonly Role[];

/** Эти роли не передаются замещением (FR-018а). Роль, полученная по замещению, — тоже. */
export const nonTransferableRoles = ['support'] as const satisfies readonly Role[];

export function isInstallationOnlyRole(role: Role): boolean {
  return (installationOnlyRoles as readonly Role[]).includes(role);
}
